import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  styles: [
    `
      .dinki-logo-img {
        height: 44px;
        width: 44px;
        object-fit: contain; /* jamais déformé, conserve le ratio 1:1 du SVG */
        display: block;
      }
      .dinki-wordmark {
        font-family: Georgia, 'Times New Roman', serif;
        font-weight: 700;
        font-size: 20px;
        letter-spacing: 1px;
        line-height: 1;
        color: var(--mat-sys-on-surface, #1a1a1a);
      }
    `,
  ],
  template: `
    <div class="flex items-center gap-2">
      <a [routerLink]="['/']" class="logodark flex items-center gap-2">
        <img
          src="assets/images/logos/logo_icon.png"
          class="dinki-logo-img rtl:-scale-x-100"
          alt="Dinki — gestion d'atelier de couture"
        />
        <span class="dinki-wordmark">Đinki</span>
      </a>

      <a [routerLink]="['/']" class="logolight flex items-center gap-2">
        <img
          src="assets/images/logos/logo_icon.png"
          class="dinki-logo-img rtl:-scale-x-100"
          alt="Dinki — gestion d'atelier de couture"
        />
        <span class="dinki-wordmark" style="color: #F2EAD3;">Đinki</span>
      </a>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}
}
